import { key } from '@connect-x-app/shared-test-ids';

export const ADMIN_TEST_IDS = {
  channelConfig: {
    modal: 'admin.channelConfig.modal.edit',
    table: 'admin.channelConfig.view.table',
  },
  confirmationModal: {
    cancel: 'admin.confirmationModal.button.cancel',
    confirm: 'admin.confirmationModal.button.confirm',
    modal: 'admin.confirmationModal.modal.root',
  },
  general: {
    page: 'admin.general.view.page',
  },
  quickReply: {
    modal: 'admin.quickReply.modal.edit',
  },
  roles: {
    formCancel: 'admin.roles.button.formCancel',
    formSubmit: 'admin.roles.button.formSubmit',
    permissionCheckbox: 'admin.roles.checkbox.permission',
    permissionsSpinner: 'admin.roles.view.permissionsSpinner',
    permissionsTable: (permissionType: string) => `admin.roles.view.permissionsTable.${key(permissionType)}`,
    screen: 'admin.roles.view.screen',
    updateConfirmation: 'admin.roles.modal.updateConfirmation',
  },
  shared: {
    add: 'admin.shared.button.add',
    collapseToggle: 'admin.shared.button.collapseToggle',
    delete: 'admin.shared.button.delete',
    emptyState: 'admin.shared.view.emptyState',
    save: 'admin.shared.button.save',
    selectCheckbox: 'admin.shared.checkbox.select',
  },
  smartActions: {
    screen: 'admin.smartActions.view.screen',
    spinner: 'admin.smartActions.view.spinner',
    tables: 'admin.smartActions.view.tables',
  },
  systemMessages: {
    modal: 'admin.systemMessages.modal.edit',
    tables: 'admin.systemMessages.view.tables',
  },
} as const;
